import React from "react";
import { OfficeProperties } from "../types/office.type";
import { Row, Col, Typography, Image } from "antd";

type Props = {
	office: OfficeProperties;
};

const { Text } = Typography;
const OfficeLabel: React.FC<Props> = ({ office }) => {
	return (
		<Row
			gutter={[24, 0]}
			align="middle"
		>
			{office?.logo?.fileUrl ? (
				<Col flex="100px">
					<Image
						fallback="/images/fallback-logo.png"
						preview={false}
						src={office.logo.fileUrl}
						alt={"Logo " + office.officeName}
						style={{ maxWidth: "100px", maxHeight: "100px" }}
					/>
				</Col>
			) : (
				<React.Fragment></React.Fragment>
			)}
			<Col flex="auto">
				<Text strong={true}>{office.officeName}</Text>
				<br />
				<Text ellipsis={true}>{office.address}</Text>
			</Col>
		</Row>
	);
};
export default OfficeLabel;
